var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNzx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 42,
    viewBox: "0 0 156 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.129 0H0.101074V41.9084H112.129L133.544 21.0035L112.129 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.545 21.0035L155.061 41.9084V0L133.545 21.0035Z",
    fill: "#0061A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.545 21.0033L112.129 41.9082H155.061L133.545 21.0033Z",
    fill: "#3397D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.545 21.0035L112.129 0H155.061L133.545 21.0035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8452 35.1044L87.5821 26.4269L81.2181 35.1044H70.4092L82.4303 20.7076L71.2173 7.0011H81.9252L87.5821 14.8898L93.1381 7.0011H103.947L92.6329 20.7076L104.654 35.1044H93.8452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.124 35.0058V29.6809L56.8726 13.1148H42.8312V7.0011H68.1864V12.3259L53.4379 28.8921H68.1864V35.0058H42.124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8002 35.0058L17.5771 20.9049V35.0058H8.08154V7.0011H16.3649L28.5879 21.102V7.0011H38.0835V35.0058H29.8002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155.061,
    height: 41.9084,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNzx);
export default __webpack_public_path__ + "static/media/nzx.9657ee6cec4534b27c637bce1ce8418e.svg";
export { ForwardRef as ReactComponent };